import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const getAccessEquipmentsService = async () => {
    try {
        const configs = getConfigExactian('GET')
        const response = await customFetch(`${API_URL}accessEquipmentsType`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}